// Справочник улиц Слюдянского района для текстовых подсказок в поле адреса.
// Только текст: названия улиц и населённый пункт, без координат и геокодинга.
// Используется чисто для подсказок по названию.
const STREETS = [
  { n: "1-я Байкальская улица", l: "Утулик" },
  { n: "2-я Байкальская улица", l: "Утулик" },
  { n: "2-я Байкальская улица", l: "Байкальск" },
  { n: "2-я Набережная улица", l: "Култук" },
  { n: "6-я Байкальская улица", l: "Байкальск" },
  { n: "7-я улица", l: "Байкальск" },
  { n: "Амбулаторная улица", l: "Слюдянка" },
  { n: "Ангарский переулок", l: "Слюдянка" },
  { n: "Базовый переулок", l: "Слюдянка" },
  { n: "Байкальская улица", l: "Байкальск" },
  { n: "Байкальская улица", l: "Култук" },
  { n: "Байкальский переулок", l: "Култук" },
  { n: "Безымянный переулок", l: "Слюдянка" },
  { n: "Береговая улица", l: "Утулик" },
  { n: "Береговой переулок", l: "Слюдянка" },
  { n: "Берёзовый переулок", l: "Байкальск" },
  { n: "Берёзовый переулок", l: "Слюдянка" },
  { n: "Болотная улица", l: "Слюдянка" },
  { n: "Большой переулок", l: "Слюдянка" },
  { n: "Брусничный переулок", l: "Слюдянка" },
  { n: "Вербная улица", l: "Култук" },
  { n: "Вербная улица", l: "Слюдянка" },
  { n: "Волгоградский переулок", l: "Слюдянка" },
  { n: "Горная улица", l: "Слюдянка" },
  { n: "Горная улица", l: "Утулик" },
  { n: "Горная улица", l: "" },
  { n: "Горная улица", l: "Култук" },
  { n: "Горный переулок", l: "Утулик" },
  { n: "Горняцкая улица", l: "Слюдянка" },
  { n: "Гранитная улица", l: "Слюдянка" },
  { n: "Дачный переулок", l: "Слюдянка" },
  { n: "Депутатская улица", l: "Култук" },
  { n: "Дивизионная улица", l: "Култук" },
  { n: "дорога к Иркуту", l: "Быстрая" },
  { n: "Дорожная улица", l: "Слюдянка" },
  { n: "Железнодорожная улица", l: "Байкальск" },
  { n: "Железнодорожная улица", l: "Слюдянка" },
  { n: "Железнодорожная улица", l: "Култук" },
  { n: "Железнодорожный переулок", l: "Култук" },
  { n: "Заводская улица", l: "Ангасолка" },
  { n: "Заречная улица", l: "Слюдянка" },
  { n: "Зелёная улица", l: "Слюдянка" },
  { n: "Зелёная улица", l: "Мангутай" },
  { n: "Зелёный переулок", l: "Мангутай" },
  { n: "Известковый переулок", l: "Слюдянка" },
  { n: "Иркутный переулок", l: "Тибельти" },
  { n: "Каменная улица", l: "Слюдянка" },
  { n: "Карьерная улица", l: "Слюдянка" },
  { n: "Кедровый переулок", l: "Слюдянка" },
  { n: "Кедровый переулок", l: "Утулик" },
  { n: "Кедровый переулок", l: "Быстрая" },
  { n: "Кедровый переулок", l: "Тибельти" },
  { n: "Ключевой переулок", l: "Слюдянка" },
  { n: "Колхозная улица", l: "Слюдянка" },
  { n: "Коммунальная улица", l: "Слюдянка" },
  { n: "Коммунальный переулок", l: "Слюдянка" },
  { n: "Комсомольская улица", l: "Слюдянка" },
  { n: "Комсомольская улица", l: "Байкальск" },
  { n: "Комсомольская улица", l: "Култук" },
  { n: "Кооперативный переулок", l: "Култук" },
  { n: "Красноармейская улица", l: "Слюдянка" },
  { n: "Красногвардейская улица", l: "Утулик" },
  { n: "Красногвардейский переулок", l: "Слюдянка" },
  { n: "Кругобайкальская улица", l: "Слюдянка" },
  { n: "Кузнечный переулок", l: "Култук" },
  { n: "Ленинградская улица", l: "Слюдянка" },
  { n: "Лесная улица", l: "Мангутай" },
  { n: "Лесная улица", l: "Утулик" },
  { n: "Лесная улица", l: "Быстрая" },
  { n: "Линейная улица", l: "Сухой Ручей" },
  { n: "Магистральная улица", l: "Слюдянка" },
  { n: "Магистральная улица", l: "Утулик" },
  { n: "Магистральный переулок", l: "Слюдянка" },
  { n: "Мало-Болотный переулок", l: "Слюдянка" },
  { n: "Малый переулок", l: "Слюдянка" },
  { n: "Мирный переулок", l: "Слюдянка" },
  { n: "Молодёжная улица", l: "Тибельти" },
  { n: "Молодёжный переулок", l: "Быстрая" },
  { n: "Московская улица", l: "Слюдянка" },
  { n: "Московская улица", l: "Култук" },
  { n: "Мостовая улица", l: "Слюдянка" },
  { n: "Набережная улица", l: "Слюдянка" },
  { n: "Набережная улица", l: "Байкальск" },
  { n: "Набережная улица", l: "Буровщина" },
  { n: "Набережная улица", l: "Утулик" },
  { n: "Новая Ангарская улица", l: "Слюдянка" },
  { n: "Новая улица", l: "Утулик" },
  { n: "Ново-Советская улица", l: "Култук" },
  { n: "Новоболотный переулок", l: "Слюдянка" },
  { n: "Новый переулок", l: "Байкальск" },
  { n: "Оборонный переулок", l: "Култук" },
  { n: "Озёрная улица", l: "Слюдянка" },
  { n: "Озёрная улица", l: "Утулик" },
  { n: "Озёрная улица", l: "Байкальск" },
  { n: "Октябрьская улица", l: "Слюдянка" },
  { n: "Октябрьская улица", l: "Култук" },
  { n: "Островная улица", l: "Слюдянка" },
  { n: "Островная улица", l: "Утулик" },
  { n: "Партизанская улица", l: "Култук" },
  { n: "Партизанский переулок", l: "Слюдянка" },
  { n: "Первомайская улица", l: "Слюдянка" },
  { n: "Перевальская улица", l: "Слюдянка" },
  { n: "переулок Гастелло", l: "Слюдянка" },
  { n: "переулок Лермонтова", l: "Слюдянка" },
  { n: "переулок Маяковского", l: "Слюдянка" },
  { n: "переулок Осипенко", l: "Слюдянка" },
  { n: "переулок Пушкина", l: "Култук" },
  { n: "Песчаная улица", l: "Слюдянка" },
  { n: "Песчаный переулок", l: "Слюдянка" },
  { n: "Пионерский переулок", l: "Слюдянка" },
  { n: "Пионерский переулок", l: "Байкальск" },
  { n: "Подгорная улица", l: "Слюдянка" },
  { n: "подъезд к Ангасолке", l: "Ангасолка" },
  { n: "Подъезд к г. Байкальску", l: "Байкальск" },
  { n: "подъезд к Тёмной пади", l: "Ангасолка" },
  { n: "Полевая улица", l: "Слюдянка" },
  { n: "Почтовый переулок", l: "Слюдянка" },
  { n: "Привокзальная улица", l: "" },
  { n: "Привокзальная улица", l: "Байкальск" },
  { n: "Привокзальная улица", l: "Култук" },
  { n: "Привокзальная улица", l: "Утулик" },
  { n: "Привокзальный переулок", l: "Слюдянка" },
  { n: "проезд Школьный", l: "Утулик" },
  { n: "Пролетарская улица", l: "Слюдянка" },
  { n: "Пролетарский переулок", l: "Слюдянка" },
  { n: "Профсоюзная улица", l: "Сухой Ручей" },
  { n: "Профсоюзная улица", l: "Култук" },
  { n: "Рабочая улица", l: "Култук" },
  { n: "Рабочий переулок", l: "Култук" },
  { n: "Речная улица", l: "Байкальск" },
  { n: "Речной переулок", l: "Тибельти" },
  { n: "Речной переулок", l: "Утулик" },
  { n: "Родниковая улица", l: "Слюдянка" },
  { n: "Российская улица", l: "Утулик" },
  { n: "Рудничный переулок", l: "Слюдянка" },
  { n: "Рябиновая улица", l: "Слюдянка" },
  { n: "Садовая улица", l: "Утулик" },
  { n: "Саянский переулок", l: "Слюдянка" },
  { n: "Сибирский переулок", l: "Слюдянка" },
  { n: "Скальный переулок", l: "Слюдянка" },
  { n: "Слюдяная улица", l: "Слюдянка" },
  { n: "Слюдяной переулок", l: "Слюдянка" },
  { n: "Слюдянский переулок", l: "Слюдянка" },
  { n: "Снежная улица", l: "Утулик" },
  { n: "Советская улица", l: "Слюдянка" },
  { n: "Советская улица", l: "Байкальск" },
  { n: "Солнечная улица", l: "Култук" },
  { n: "Солнечный переулок", l: "Слюдянка" },
  { n: "Сосновая улица", l: "Култук" },
  { n: "Сосновый переулок", l: "Утулик" },
  { n: "Строительная улица", l: "Байкальск" },
  { n: "Строительная улица", l: "Утулик" },
  { n: "Таёжный переулок", l: "Байкальск" },
  { n: "Талая улица", l: "Талая" },
  { n: "Телевизионный переулок", l: "Слюдянка" },
  { n: "Трактовая улица", l: "Слюдянка" },
  { n: "Трактовая улица", l: "Утулик" },
  { n: "Трактовая улица", l: "Тибельти" },
  { n: "Транспортная улица", l: "Слюдянка" },
  { n: "Трудовой переулок", l: "Слюдянка" },
  { n: "Тункинский тракт", l: "" },
  { n: "Тункинский тракт", l: "Быстрая" },
  { n: "Тункинский тракт", l: "Тибельти" },
  { n: "Тункинский тракт", l: "Култук" },
  { n: "Тупиковый переулок", l: "Култук" },
  { n: "улица 0-я", l: "Байкальск" },
  { n: "улица 40 лет Октября", l: "Слюдянка" },
  { n: "улица 40 лет Победы", l: "Утулик" },
  { n: "улица 8 Марта", l: "Слюдянка" },
  { n: "улица Автомобилистов", l: "Култук" },
  { n: "улица Бабушкина", l: "Слюдянка" },
  { n: "улица Берсенёва", l: "Слюдянка" },
  { n: "улица Васильева", l: "Слюдянка" },
  { n: "улица Гагарина", l: "" },
  { n: "улица Геологов", l: "Слюдянка" },
  { n: "улица Горького", l: "Слюдянка" },
  { n: "улица Дениса Давыдова", l: "Слюдянка" },
  { n: "улица Дыбовского", l: "Култук" },
  { n: "улица Захарова", l: "Слюдянка" },
  { n: "улица Зои Космодемьянской", l: "Сухой Ручей" },
  { n: "улица Ивана Похабова", l: "Слюдянка" },
  { n: "улица Капотина", l: "Слюдянка" },
  { n: "улица Карбышева", l: "Слюдянка" },
  { n: "улица Кирова", l: "Слюдянка" },
  { n: "улица Кирова", l: "Култук" },
  { n: "улица Красина", l: "Слюдянка" },
  { n: "улица Крылова", l: "Култук" },
  { n: "улица Куприна", l: "Слюдянка" },
  { n: "улица Кутелева", l: "Слюдянка" },
  { n: "улица Лазо", l: "Слюдянка" },
  { n: "улица Лёни Полуяхтова", l: "Слюдянка" },
  { n: "улица Ленина", l: "Слюдянка" },
  { n: "улица Лермонтова", l: "Слюдянка" },
  { n: "улица Лесников", l: "Култук" },
  { n: "улица Матросова", l: "Слюдянка" },
  { n: "улица Матросова", l: "Култук" },
  { n: "улица Менделеева", l: "Слюдянка" },
  { n: "улица Мира", l: "Мангутай" },
  { n: "улица Мира", l: "Култук" },
  { n: "улица Мичурина", l: "Слюдянка" },
  { n: "улица Набережная", l: "Тибельти" },
  { n: "улица Некрасова", l: "Слюдянка" },
  { n: "улица Новосёлов", l: "Култук" },
  { n: "улица Олега Кошевого", l: "Слюдянка" },
  { n: "улица Олега Кошевого", l: "Култук" },
  { n: "улица Панфилова", l: "Слюдянка" },
  { n: "улица Панфилова", l: "Култук" },
  { n: "улица Парижской Коммуны", l: "Слюдянка" },
  { n: "улица Победы", l: "Култук" },
  { n: "улица Пушкина", l: "Слюдянка" },
  { n: "улица Пушкина", l: "" },
  { n: "улица Пушкина", l: "Култук" },
  { n: "улица Пушкина", l: "Утулик" },
  { n: "улица Ржанова", l: "Слюдянка" },
  { n: "улица Роща", l: "Култук" },
  { n: "улица Савченко", l: "Мангутай" },
  { n: "улица Свободы", l: "Слюдянка" },
  { n: "улица Слюдянских Красногвардейцев", l: "Слюдянка" },
  { n: "улица Строителей", l: "Слюдянка" },
  { n: "улица Суворова", l: "Култук" },
  { n: "улица Терешковой", l: "" },
  { n: "улица Тонконога", l: "Слюдянка" },
  { n: "улица Флагопита", l: "Слюдянка" },
  { n: "улица Фрунзе", l: "Слюдянка" },
  { n: "улица Чапаева", l: "Слюдянка" },
  { n: "улица Чапаева", l: "Култук" },
  { n: "улица Чехова", l: "Култук" },
  { n: "улица Шаманка", l: "Култук" },
  { n: "улица Щорса", l: "Слюдянка" },
  { n: "улица Энтузиастов", l: "Слюдянка" },
  { n: "Черёмуховый переулок", l: "Слюдянка" },
  { n: "Шахтёрская улица", l: "Слюдянка" },
  { n: "Школьная улица", l: "Слюдянка" },
  { n: "Школьная улица", l: "Култук" },
  { n: "Школьный переулок", l: "Байкальск" },
];

export default STREETS;
